<!-- Step 2: Background source -->
<div *ngIf="step === 2" class="wizard-step">
  <div class="step-title">{{ isEditMode ? 'Edit' : 'Create' }} Image Favorite</div>
  <div class="step-subtitle">Select the background image source</div>

  <div class="form-group">
    <label class="source-option">
      <input type="radio" name="wizardImageSource" [value]="SourceType.Static"
             [(ngModel)]="m.imageSourceType" (ngModelChange)="onSourceTypeChange()" />
      <span><strong>Static</strong> &mdash; upload an image that doesn't change</span>
    </label>
    <label class="source-option">
      <input type="radio" name="wizardImageSource" [value]="SourceType.Dynamic"
             [(ngModel)]="m.imageSourceType" (ngModelChange)="onSourceTypeChange()" />
      <span><strong>Dynamic</strong> &mdash; always show the newest image from a Scoutview gateway</span>
    </label>
  </div>
  <div class="hint">Labels (text, arrows, regions and live sensor values) are added in step 4.</div>
</div>

<!-- Step 3: The image -->
<div *ngIf="step === 3" class="wizard-step">
  <div class="step-title">{{ isEditMode ? 'Edit' : 'Create' }} Image Favorite</div>

  <ng-container *ngIf="m.imageSourceType === SourceType.Static">
    <div class="step-subtitle">Upload the background image</div>
    <div class="form-group">
      <label>Image File</label>
      <input type="file" accept="image/*" class="form-control" (change)="onFileSelected($event)" />
      <div class="hint" *ngIf="m.file != null">Selected: {{ m.file.name }}</div>
      <div class="hint" *ngIf="m.file == null && m.existingStaticImageSrc != null">Leave empty to keep the current image.</div>
    </div>
  </ng-container>

  <ng-container *ngIf="m.imageSourceType === SourceType.Dynamic">
    <div class="step-subtitle">Select the gateway that supplies the image</div>
    <div class="form-group">
      <label>Scoutview Gateway</label>
      <ng-select [items]="gateways" bindLabel="name" bindValue="serialNumber" name="wizardGateway"
                 placeholder="Select Gateway" [(ngModel)]="m.gatewaySourceId" (change)="onGatewayChange()">
      </ng-select>
    </div>
    <div class="form-group">
      <label>Media Tag (optional)</label>
      <ng-select [items]="tagSuggestions" [addTag]="true" addTagText="Use tag" name="wizardImageTag"
                 placeholder="Any tag (newest image)" [(ngModel)]="m.imageTag" (change)="onTagChange()"
                 [disabled]="m.gatewaySourceId == null">
      </ng-select>
      <div class="hint">Shows the gateway's newest image that carries this tag. The image and dynamic labels refresh every 5 minutes.</div>
    </div>
    <div class="hint" *ngIf="previewLoading">Loading the newest image ...</div>
    <div class="error-hint" *ngIf="!previewLoading && previewMissing">
      No image found for this gateway{{ m.imageTag ? ' and tag' : '' }} yet. You can still continue; it will appear once one is captured.
    </div>
  </ng-container>
</div>

<!-- Step 4: Labels -->
<div *ngIf="step === 4" class="wizard-step">
  <div class="step-title">{{ isEditMode ? 'Edit' : 'Create' }} Image Favorite</div>
  <div class="step-subtitle">Add labels (optional)</div>
  <div class="hint">
    Click <strong>Labels</strong> above the preview to open the label editor, then add labels and drag them
    (and their arrow tips or region corners) into place on the image.
  </div>
  <ul class="hint" style="margin-top: 10px;">
    <li>Text + arrow, sticky notes and text boxes annotate the image.</li>
    <li>Highlighted regions outline an area.</li>
    <li>Check <strong>Dynamic (sensor value)</strong> to show a live reading &mdash; the last value, or the average/median/min/max of the last X minutes.</li>
  </ul>
  <div class="hint" style="margin-top: 10px;">
    {{ m.labels.length }} label(s){{ dynamicLabelCount > 0 ? ', ' + dynamicLabelCount + ' dynamic' : '' }}.
  </div>
</div>

<!-- Step 5: Save -->
<div *ngIf="step === 5" class="wizard-step">
  <div class="step-title">{{ isEditMode ? 'Edit' : 'Create' }} Image Favorite</div>

  <div class="step-subtitle">Save Image Favorite</div>
  <div class="form-group">
    <label>Image Favorite Name</label>
    <input type="text" name="wizardImageFavoriteName" class="form-control" placeholder="Image Favorite" maxlength="256"
           [class.input-error]="favoriteNameTaken"
           [(ngModel)]="m.favoriteName" (ngModelChange)="onSaveFieldChanged()" />
    <div class="error-hint" *ngIf="favoriteNameTaken">An image favorite with this name already exists.</div>
  </div>
  <div class="form-group">
    <label>Access Group</label>
    <ngx-select-dropdown [(ngModel)]="m.favoriteUserGroup" [config]="userGroupConfig"
                         [options]="associatedUserGroups" name="wizardImageFavoriteGroup"></ngx-select-dropdown>
  </div>

  <ng-container *ngIf="!isEditMode">
    <div class="step-subtitle" style="margin-top: 18px;">Create or update dashboard</div>
    <div class="form-group radio-row">
      <label>
        <input type="radio" name="wizardImageDashTarget" value="new"
               [(ngModel)]="m.dashboardTargetMode" (ngModelChange)="onSaveFieldChanged()" /> Add to new dashboard
      </label>
      <label>
        <input type="radio" name="wizardImageDashTarget" value="existing"
               [(ngModel)]="m.dashboardTargetMode" (ngModelChange)="onSaveFieldChanged()" /> Add to existing dashboard
      </label>
    </div>

    <div class="form-group" *ngIf="m.dashboardTargetMode === 'new'">
      <input type="text" name="wizardImageNewDashName" class="form-control" placeholder="New dashboard name"
             [class.input-error]="newDashboardNameTaken"
             [(ngModel)]="m.newDashboardName" (ngModelChange)="onSaveFieldChanged()" />
      <div class="error-hint" *ngIf="newDashboardNameTaken">A dashboard with this name already exists.</div>
    </div>
    <div class="form-group" *ngIf="m.dashboardTargetMode === 'existing'">
      <ng-select [items]="dashboards"
                 bindLabel="name"
                 placeholder="Select Dashboard"
                 [(ngModel)]="m.targetDashboard"
                 (ngModelChange)="onSaveFieldChanged()">
      </ng-select>
    </div>
  </ng-container>

  <div class="hint" *ngIf="isEditMode">Finish will update this image favorite and its labels.</div>
</div>
